/* eslint-disable no-invalid-this */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '../buttons/Button';
import AlertMessage from '../message/AlertMessage';
import TextInput from '../inputs/TextInput';
import Modal from 'react-modal';

import { postTeamFontUsingTeamid, postTeamFontUsingTeamidAndFontid } from '../../api/cloudApiGenerated';

class FontModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.closeModal = this.closeModal.bind(this);
    this.changeMetaData = this.changeMetaData.bind(this);
    this.updateState = this.updateState.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.show = this.show.bind(this);

    this.state = {
      team: props.team,
      showMetaDataModal: false,
      type: 'Add',
      form: {
        name: {
          value: '',
        },
      },
      error: '',
      file: null,
    };
  }

  updateState(event) {
    const field = event.target.name;
    let form = this.state.form;
    form[field].value = event.target.value;
    return this.setState({ form });
  }

  closeModal() {
    this.setState({ showMetaDataModal: false });
  }

  changeMetaData() {
    if (this.state.form.name.value === '') {
      this.setState({
        error: 'Name field is required',
      });
      return;
    }

    if (this.state.type === 'Add') {
      const files = document.querySelector('#font').files;

      if (!files || files.length === 0) {
        this.setState({
          error: 'File is required',
        });
        return;
      }

      let formData = new FormData();

      formData.append('font', files[0]);
      formData.append('name', this.state.form.name.value);

      postTeamFontUsingTeamid(this.props.team.id, formData).then((data) => {
        this.props.snackBar('Font uploaded');
        this.props.refreshFonts(this.props.team);
        this.closeModal();
      });
    } else {
      const files = document.querySelector('#font').files,
        formData = new FormData();

      formData.append('font', files[0]);
      formData.append('name', this.state.form.name.value);

      postTeamFontUsingTeamidAndFontid(this.props.team.id, this.props.selectedFont.id, formData).then((data) => {
        this.props.snackBar('Font updated');
        this.props.refreshFonts(this.props.team);
        this.closeModal();
      });
    }
  }

  show(type) {
    const form = this.state.form;
    form.name.value = type === 'Edit' ? this.props.selectedFont.name : '';

    this.setState({
      type,
      form,
      showMetaDataModal: true,
    });
  }

  onFileChange(e) {
    this.setState({
      file: e.target.files,
    });
  }

  render() {
    let form = this.state.form;

    return (
      <Modal
        overlayClassName="hc-modal-overlay"
        appElement={document.querySelector('.page-container')}
        isOpen={this.state.showMetaDataModal}
        contentLabel="Change Details"
        onRequestClose={this.closeModal}
        className="hc-modal-content"
      >
        <h3 className="chart-modal-header">{this.state.type} font</h3>
        <div className="row row-centered">
          {this.state.error && <AlertMessage type="danger" hideTag={true} text={this.state.error} />}

          <form role="form">
            <label htmlFor="name"> Name: </label>
            <TextInput
              name="name"
              onChange={this.updateState}
              placeholder="Name"
              value={form.name.value}
              autoFocus={true}
            />
            <div>
              <label htmlFor="private"> File: </label>
            </div>
            <div>
              <input type="file" id="font" name="font" accept="font/*" onChange={this.onFileChange} />
            </div>
            <Button buttonClass="btn-primary" buttonText="Save" onClick={this.changeMetaData} />
            <Button buttonClass="btn-secondary" buttonText="Cancel" onClick={this.closeModal} />
          </form>
        </div>
      </Modal>
    );
  }
}

FontModal.propTypes = {
  team: PropTypes.object,
  snackBar: PropTypes.func,
  refreshFonts: PropTypes.func,
  selectedFont: PropTypes.object,
};

export default FontModal;
